export const locale = {
    lang: "pt-BR",
    data: {
        ADD_CREDIT_CARD: {
            TITLE: "Adicionar novo cartão de crédito",
            NUMBER: {
                LABEL: "Número do cartão",
                ERROR: "Número do cartão inválido"
            },
            HOLDER: {
                LABEL: "Nome no cartão",
                ERROR: "Nome no cartão inválido"
            },
            EXPIRY: {
                LABEL: "Validade",
                PLACE_HOLDER: "MM/AA",
                ERROR: "Validade inválida"
            },
            SECURITY_CODE: {
                LABEL: "CVV",
                ERROR: "CVV inválido"
            },
            PHONE: {
                LABEL: "Telefone",
                ERROR: "Telefone inválido"
            },
            ADD_BUTTON: "Salvar",
            IS_DEFAULT: "Usar como padrão",
            CANCEL_BUTTON: "Cancelar"
        }
    }
};
